export const ms = {
    LEFT: 'Kiri: Pindah ke hari sebelumnya.',
    RIGHT: 'Kanan: Bergerak ke hari berikutnya.',
    DOWN: 'Ke bawah: Bergerak ke depan baris.',
    UP: 'Sehingga: Bergerak ke baris sebelumnya.',
    PGUP: 'PgUp: Pindah ke bulan sebelumnya.',
    PGDOWN: 'PgDown: Pindah ke bulan depan.',
    HOME: 'Rumah: Pindah ke tahun sebelumnya.',
    END: 'Akhir: Pindah ke tahun depan.',
    ESC: 'Escudo/Hari ini/Tutup: dekat kalendar.',
    TITLE: 'Keyboard Arahan'
};
